module.exports = __webpack_public_path__ + "static/img/22-1.df21266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/22-1.jpg
// module id = I7Ac
// module chunks = 0